import cartApiFactory from '../../modules/cart/cartApi';

/* Utils */
import {
  generateDefaultAsyncWatcher,
  generateDefaultAsyncSaga,
} from '../core/reduxUtils';

/* Actions */
import {
  addToCartActionCreators,
  getCartItemCountActionCreators,
} from '../actions/cartActions';

function cartSagasFactory({storefrontApiClient}) {
  const cartApi = cartApiFactory(storefrontApiClient);

  const addToCartSaga = generateDefaultAsyncSaga(
    cartApi.addToCart,
    addToCartActionCreators,
    payload => [
      payload.item,
    ]
  );

  const getCartItemCountSaga = generateDefaultAsyncSaga(
    cartApi.getCartItemCount,
    getCartItemCountActionCreators,
    payload => [
      payload.params,
    ]
  );

  const watchAddToCart = generateDefaultAsyncWatcher(
    'ADD_TO_CART',
    addToCartSaga
  );

  const watchGetCartItemCount = generateDefaultAsyncWatcher(
    'GET_CART_ITEM_COUNT',
    getCartItemCountSaga,
  );

  const cartSagas = [
    watchAddToCart(),
    watchGetCartItemCount(),

  ];

  return cartSagas;
}

export default cartSagasFactory;
